const track = (eventName: string, properties?: Record<string, any>) => {
  // @ts-expect-error
  window.dataLayer.push({ event: eventName, ...properties });
};

export const TagManager = { track };
